import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { BOOKING_URL } from "@/photos";
import { EASE } from "./Reveal";

const NAV_KEYS = [
  ["casa", "#casa"],
  ["servizi", "#servizi"],
  ["colazione", "#colazione"],
  ["dintorni", "#dintorni"],
  ["regole", "#regole"],
];

export default function Header() {
  const { lang, setLang, t } = useLang();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: EASE }}
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,box-shadow,backdrop-filter] duration-500 ${
        scrolled
          ? "bg-white/80 backdrop-blur-xl shadow-[0_1px_0_0_rgba(20,184,166,0.15)]"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" className="flex items-center" data-testid="header-logo">
          <span className="rounded-2xl bg-white/95 px-3 py-1.5 shadow-md shadow-stone-950/10">
            <img src="/logo.png" alt="Welcome Love House Roma" className="h-10 w-auto sm:h-11" />
          </span>
        </a>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="header-nav">
          {NAV_KEYS.map(([key, href]) => (
            <a
              key={key}
              href={href}
              className={`text-sm font-medium transition-colors duration-300 hover:text-pink-500 ${
                scrolled ? "text-stone-700" : "text-white/85"
              }`}
            >
              {t.nav[key]}
            </a>
          ))}
          <a
            href="#recensioni"
            className={`text-sm font-medium transition-colors duration-300 hover:text-pink-500 ${
              scrolled ? "text-stone-700" : "text-white/85"
            }`}
          >
            {lang === "it" ? "Recensioni" : "Reviews"}
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => setLang(lang === "it" ? "en" : "it")}
            data-testid="language-toggle-button"
            className={`flex items-center rounded-full border px-3 py-1.5 text-xs font-bold tracking-widest transition-colors duration-300 ${
              scrolled
                ? "border-teal-600/30 text-teal-700 hover:bg-teal-50"
                : "border-white/40 text-white hover:bg-white/10"
            }`}
          >
            <span className={lang === "it" ? "text-pink-500" : "opacity-50"}>IT</span>
            <span className="mx-1.5 opacity-40">/</span>
            <span className={lang === "en" ? "text-pink-500" : "opacity-50"}>EN</span>
          </button>
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-booking-cta"
            className="hidden rounded-full bg-pink-600 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-pink-600/25 transition-[transform,background-color] duration-300 hover:scale-105 hover:bg-pink-700 sm:inline-block"
          >
            {t.nav.cta}
          </a>
        </div>
      </div>
    </motion.header>
  );
}
